import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'
import languagesConfig from '@languages'

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: languagesConfig.default,
    supportedLngs: languagesConfig.supported,

    ns: ['common', 'auth', 'cameras', 'events', 'settings', 'groups', 'users', 'notifications', 'detectionAccuracy'],
    defaultNS: 'common',

    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      queryStringParams: { v: Date.now().toString(36) }, // Cache bust on each app load
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    // Missing key detection — logs warnings in development
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: (_lngs, ns, key) => {
      if (import.meta.env.DEV) {
        console.warn(`[i18n] Missing translation: ${ns}:${key}`)
      }
    },

    react: {
      useSuspense: true,
    },
  })

export default i18n
